import { mainInstance } from "api";
import { PAGE_SIZE } from "utils/Constans";

const getOnlineExamTemplateDetails = async ({ examTemplateId }) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamTemplates/${examTemplateId}/Details
    `
  );
  return data.data;
};
const postOnlineExamTemplate = async ({ body }) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamTemplates
    `,
    body
  );
  return data.data;
};
const editOnlineExamTemplateDetails = async ({ body }) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/OnlineExamTemplates
    `,
    body
  );
  return data.data;
};
const getOnlineExamTemplates = async (
  { filterBody, semesterId, schoolId, pageSize = PAGE_SIZE },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamTemplates?SemesterId=${semesterId}&SchoolId=${schoolId}&PageIndex=${page}&PageSize=${pageSize}&Title=${
      filterBody?.title || ""
    }`
  );
  return data.data;
};
const deleteOnlineExamTemplate = async ({ examId, semesterId }) => {
  const { data } = await mainInstance.delete(
    `/api/teacher/v3.0/OnlineExamTemplates/${semesterId}/${examId}`
  );
  return data.data;
};
const publicOnlineExamTemplate = async ({ examTemplateId, isPublic }) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamTemplates/${examTemplateId}/RequestPublic/${isPublic}`
  );
  return data.data;
};
const cloneOnlineExamTemplate = async ({
  templateId,
  schoolId,
  semesterId,
}) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamTemplates/CloneToExam/${schoolId}/${semesterId}/${templateId}`
  );
  return data.data;
};
const postOnlineExamTemplateQuestionList = async ({
  body,
  onlineExamTemplateId,
  schoolId,
}) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamTemplateQuestion/OnlineExamTemplates/${schoolId}/${onlineExamTemplateId}/PostList`,
    body
  );
  return data.data;
};
const getOnlineExamTemplateQuestion = async (
  { schoolId, semesterId, title, pageSize = PAGE_SIZE },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamTemplateQuestion?SchoolId=${schoolId}&SemesterId=${semesterId}&Title=${
      title || ""
    }&PageIndex=${page}&PageSize=${pageSize}`
  );
  return data.data;
};
const searchOnlineExamTemplateQuestion = async (
  { questionType, schoolId, semesterId, title, pageSize = PAGE_SIZE },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamTemplateQuestion/Search?SchoolId=${schoolId}&SemesterId=${semesterId}&Title=${title}&PageIndex=${page}&PageSize=${pageSize}&QuestionType=${questionType}`
  );
  return data.data;
};
const postOnlineExamTemplateQuestionQuestionList = async ({
  body,
  schoolId,
}) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/OnlineExamTemplateQuestion/OnlineExamTemplates/${schoolId}/PostList`,
    body
  );
  return data.data;
};
const deleteOnlineExamQuestionTemplate = async ({ id, schoolId }) => {
  const { data } = await mainInstance.delete(
    `/api/teacher/v3.0/OnlineExamTemplateQuestion/${schoolId}/${id}`
  );
  return data.data;
};

const publicOnlineExamQuestionTemplate = async ({
  examTemplateQuestionId,
  isPublic,
}) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/OnlineExamTemplateQuestion/${examTemplateQuestionId}/RequestPublic/${isPublic}/`
  );
  return data.data;
};

export {
  getOnlineExamTemplateDetails,
  editOnlineExamTemplateDetails,
  postOnlineExamTemplate,
  getOnlineExamTemplates,
  deleteOnlineExamTemplate,
  publicOnlineExamTemplate,
  cloneOnlineExamTemplate,
  postOnlineExamTemplateQuestionList,
  postOnlineExamTemplateQuestionQuestionList,
  getOnlineExamTemplateQuestion,
  deleteOnlineExamQuestionTemplate,
  publicOnlineExamQuestionTemplate,
  searchOnlineExamTemplateQuestion,
};
